
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/smart-swap",
      function () {
        return require("private-next-pages/info/smart-swap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/smart-swap"])
      });
    }
  